<template>
    <button 
        class="item-button p-4 rounded font-medium transition-colors cursor-pointer"
        :class="` button-${variant} ${variant == 'primary' ? 'bg-blue-600 hover:bg-blue-500' : 'bg-zinc-700 hover:bg-zinc-600'} `"
        @click="$emit('click')"
    >
        {{ label }}
    </button>
</template>

<script>
export default {
    name: 'ItemButton',
    props: {
        label: {
            type: String,
            required: true
        },
        variant: {
            type: String,
            default: 'primary',
            validator: value => ['primary', 'secondary'].includes(value)
        }
    },
    emits: ['click'],
}
</script>
